export async function copyTextToClipboard(text: string) {
  if ("clipboard" in navigator) {
    return await navigator.clipboard.writeText(text);
  } else {
    return document.execCommand("copy", true, text);
  }
}

export async function handleCopyClick(text: string, messageApi: any) {
  copyTextToClipboard(text)
    .then((res) => {
      console.log(res);
      messageApi();
    })
    .catch((err) => {
      throw new Error("Fail to Copy text");
    });
}
